import { handlers as authorization } from './api/auth/auth';
import { handlers as personalArea } from './api/personalArea/personalArea';
import { handlers as other } from './api/other/other';
import { handlers as roaming } from './api/roaming/roaming';
import { handlers as phoneFilter } from './api/phoneFilter/phoneFilter';
import { handlers as unpaidAmoutAndUsedbytes } from './api/unpaidAmoutAndUsedbytes/unpaidAmoutAndUsedbytes';
import { handlers as bookingMsisdn } from './api/bookingMsisdn/bookingMsisdn';
import { handlers as storeInfo } from './api/storeInfo/storeInfo';
import { handlers as storeReserve } from './api/storeReserve/storeReserve';
import { handlers as autoPay } from './api/autoPay/autoPay';
import { handlers as paymentTool } from './api/paymentTool/paymentTool';
import { handlers as international } from './api/international/international';
import { handlers as happyGo } from './api/happyGo/happyGo';
import { handlers as payment } from './api/payment/payment';
import { handlers as electronicInvoice } from './api/electronicInvoice/electronicInvoice';
import { handlers as cfgMsg } from './api/cfgMsg/cfgMsg';
import { handlers as autoRechargeInit } from './api/autoRechargeInit/autoRechargeInit';
import { handlers as usedbytesSearchController } from './api/usedbytesSearchController/usedbytesSearchController';
import { handlers as initUsedBytesInfo } from './api/initUsedBytesInfo/initUsedBytesInfo';
import { handlers as queryRateChangeList } from './api/queryRateChangeList/queryRateChangeList';
import { handlers as AuthorizeController } from './api/AuthorizeController/AuthorizeController';
import { handlers as safetyAuthorize } from './api/safetyAuthorize/safetyAuthorize';
import { handlers as paymentController } from './api/paymentController/paymentController';
import { handlers as contractController } from './api/contractController/contractController';
import { handlers as FcoinController } from './api/FcoinController/FcoinController';
import { handlers as parkingfeeController } from './api/parkingfeeController/parkingfeeController';
import { handlers as personalAreaLayout } from './api/personalAreaLayout/personalAreaLayout';
import { handlers as fetnetPortal } from './api/fetnetPortal/fetnetPortal';
import { handlers as surfProtector } from './api/surfProtector/surfProtector';
import { handlers as rateController } from './api/rateController/rateController';
import { handlers as functionDataController } from './api/functionDataController/functionDataController';
import { handlers as callerIdentify } from './api/callerIdentify/callerIdentify';
import { handlers as billSearchController } from './api/billSearchController/billSearchController';
import { handlers as fiveGsaController } from './api/5gsaController/5gsaController';

export const handlers = [
  ...authorization,
  ...personalArea,
  ...other,
  ...roaming,
  ...phoneFilter,
  ...bookingMsisdn,
  ...unpaidAmoutAndUsedbytes,
  ...storeInfo,
  ...storeReserve,
  ...autoPay,
  ...paymentTool,
  ...international,
  ...happyGo,
  ...payment,
  ...electronicInvoice,
  ...cfgMsg,
  ...autoRechargeInit,
  ...usedbytesSearchController,
  ...initUsedBytesInfo,
  ...queryRateChangeList,
  ...AuthorizeController,
  ...safetyAuthorize,
  ...paymentController,
  ...contractController,
  ...FcoinController,
  ...parkingfeeController,
  ...personalAreaLayout,
  ...fetnetPortal,
  ...surfProtector,
  ...rateController,
  ...functionDataController,
  ...callerIdentify,
  ...billSearchController,
  ...fiveGsaController,
];
